<template>
  <div class="tw:bg-blue-200 tw:flex tw:items-center tw:justify-start tw:border tw:rounded-lg tw:px-3 tw:py-3">
    <Bulb
      class="tw:fill-none tw:stroke-blue-700 tw:h-5 tw:w-3 tw:shrink-0 tw:overflow-visible"
      v-if="iconType === 'bulb'"
    />
    <Information v-else-if="iconType === 'info'" class="tw:mt-0.5 tw:fill-blue-700 tw:mt-[2px] tw:size-5" />
    <div class="text tw:ml-3">
      <slot />
    </div>
  </div>
</template>

<script setup>
import Bulb from '@/components/icons/Bulb.svg?component'
import Information from '@/components/icons/Information.svg?component'

defineProps({
  iconType: {
    type: String,
    default: 'bulb',
  },
})
</script>
<style scoped>
.text :deep(a) {
  text-decoration: underline;
}
</style>
